import { Image, TextLink, Typography, useMediaQueryContext } from "@drone-js/core";
import { HStack, VStack } from "apps/commons/components/Stack";
import { useDisclosure } from "apps/commons/hooks/useDisclosure";
import type { PropertyData } from "libs/codegen/property-onboarding";
import { OneOnboardingImages } from "libs/images/oneOnboarding";
import { Fragment } from "react";
import { useWatch } from "react-hook-form";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { ContentPolicyModal } from "./ContentPolicyModal";

export const EligibleOnly = () => {
    const externalProperty = useWatch<PropertyData>({
        name: "externalProperty",
    }) as boolean;
    const { open, onOpen, onClose } = useDisclosure();
    const context = useMediaQueryContext();
    const {
        cmsData: {
            photo: { useEligiblePhotosOnly, usePhotosThatYouOwnOrHaveTheRightsToDisplay, contentPolicy },
        },
    } = useStaticDataAtomValue();

    if (!externalProperty) return null;

    return (
        <Fragment>
            <HStack gap="24" borderRadius="8" p="16" backgroundColor="base.inset">
                {context.m && <Image src={OneOnboardingImages.AgojiImage} alt="Agoji" width="80px" height="95px" />}
                <VStack gap="16">
                    <Typography variant="body-default-strong">📷 {useEligiblePhotosOnly}</Typography>
                    <Typography>
                        {usePhotosThatYouOwnOrHaveTheRightsToDisplay.split(" ").map((text, index) => {
                            if (text.startsWith("{") && text.match(/{(\d+)}/) !== null)
                                switch (text.match(/{(\d+)}/)[1]) {
                                    case "0":
                                        return <TextLink label={contentPolicy} onClick={onOpen} />;
                                    default:
                                        return text;
                                }
                            else if (index !== 0) return " " + text;
                            else return text;
                        })}
                    </Typography>
                </VStack>
            </HStack>
            <ContentPolicyModal visible={open} onClose={onClose} />
        </Fragment>
    );
};
